'use strict';

import ko from 'knockout';
import Article from 'models/Article';
import BaseApp from 'viewmodels/pc/BaseApp';

class App extends BaseApp
{
  /**
   * アプリケーションインスタンスを生成します。
   *
   * @constructor
   * @throws {Error} 記事ページではない
   */
  constructor() {
    super();

    let matches = location.pathname.match(/^\/(\d+)\/?$/);

    if (!matches) {
      throw new Error('');
    }

    this.favorited = ko.observable(false);
    this.favorite = ko.observable(0);
    this.article = new Article(matches[1]);
  }

  onToggleFavorite() {
    if (this.favorited()) {
      this.onRemoveFavorite();
    } else {
      this.onAddFavorite();
    }
  }

  /** お気に入り追加時に実行するイベントハンドラ */
  onAddFavorite() {
    this.article.addFavorite()
      .done((() => {
        this.favorite(this.favorite() + 1);
        this.favorited(true);
      }).bind(this))
      .fail((jqXHR, textStatus, errorThrown) => {
        if ('Forbidden' === errorThrown) {
          window.location.href = '/users/sign_in';
          return;
        }
        alert('エラーが発生しました。');
      });
  }

  /** お気に入り削除時に実行するイベントハンドラ */
  onRemoveFavorite() {
    this.article.removeFavorite()
      .done((() => {
        this.favorite(this.favorite() - 1);
        this.favorited(false);
      }).bind(this))
      .fail(() => {
        alert('エラーが発生しました。');
      });
  }
}

ko.applyBindings(new App());



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./assets/scripts/apps/pc/article_view.babel.js
 **/